export const UPDATE_COLOR_SCALE = 'UPDATE_COLOR_SCALE';

export const changeColorScale = (visualization, colorScaleOption) => ({
    type: UPDATE_COLOR_SCALE,
    visualization,
    colorScaleOption,
});
